import _ from 'lodash';

export function fetchUserInterests(state, { page, sort, filter }) {
  return {
    ...state,
    userInterests: {
      ...state.userInterests,
      currentPage: page,
      sort: sort || state.userInterests.sort,
      filter: filter || state.userInterests.filter,
    },
  };
}

export function fetchUserInterestsSuccess(state, { userInterests }) {
  return {
    ...state,
    userInterests: {
      ...state.userInterests,
      totals: userInterests.totals,
      numberOfPages: userInterests.users.numberOfPages,
      count: userInterests.users.count,
      items: userInterests.users.items,
    },
  };
}

export function openUserInterestDetails(state, { userId }) {
  return {
    ...state,
    userInterestDetails: {
      formName: state.editTestDevice.formName,
      showModal: true,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
      userId,
    },
  };
}

export function closeUserInterestDetails(state) {
  return {
    ...state,
    userInterestDetails: {
      showModal: false,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
    },
  };
}

export function openUserInterestApps(state, { packages, category }) {
  return {
    ...state,
    userInterestApps: {
      showModal: true,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
      packages: _.filter(packages, x => x.category === category),
      category,
    },
  };
}

export function closeUserInterestApps(state) {
  return {
    ...state,
    userInterestApps: {
      showModal: false,
      isFetching: false,
      error: null,
      isFetchingSuccess: true,
      packages: [],
    },
  };
}

export function fetchUserInterestDetails(state) {
  return {
    ...state,
    userInterestDetails: {
      ...state.userInterestDetails,
      isFetching: true,
    },
  };
}

export function fetchUserInterestDetailsSuccess(state, { userInterestDetails }) {
  return {
    ...state,
    userInterestDetails: {
      ...state.userInterestDetails,
      isFetching: false,
      data: userInterestDetails,
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/userInterests.js
 **/